import * as React from "react";

import { ButtonStack } from "../../button-stack";

import {
  FeatureGuard,
  OneTimePasswordFeatures,
  useOneTimePasswordFieldSuggestion,
} from "../../providers";

import { InitialStateMinimumRequirements_ForgotPasswordOptionInJoining } from "../initial-state-requirements";

export interface TroubleSigningInSectionProps {
  useInitialState: () => {
    initialState: InitialStateMinimumRequirements_ForgotPasswordOptionInJoining;
  };
}
export const TroubleSigningInSection: React.FunctionComponent<
  TroubleSigningInSectionProps
> = (props) => {
  const { initialState } = props.useInitialState();
  const { forgot_password_url } = initialState || {};

  const { handleStartTheUserFlowForAOneTimeCodeBasedLogin } =
    useOneTimePasswordFieldSuggestion();

  const handleSignInWithAOneTimeCode: React.MouseEventHandler<HTMLButtonElement> =
    React.useCallback(
      (event) => {
        event.preventDefault();
        handleStartTheUserFlowForAOneTimeCodeBasedLogin();
      },
      [handleStartTheUserFlowForAOneTimeCodeBasedLogin]
    );

  return (
    <section className="trouble-signing-in">
      <p className="header">{`Having trouble signing in?`}</p>

      <ButtonStack>
        <FeatureGuard features={[OneTimePasswordFeatures.OneTimePassword]}>
          <ButtonStack.Button
            onClick={handleSignInWithAOneTimeCode}
          >{`Sign in with a one-time code`}</ButtonStack.Button>
        </FeatureGuard>
        <ButtonStack.Button
          href={forgot_password_url}
        >{`Reset your password`}</ButtonStack.Button>
      </ButtonStack>
    </section>
  );
};
